import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import SelectField from '../../../../_common/platform/tsx/SelectField';
import StringField from '../../../../_common/platform/tsx/StringField';

import { DiscreteIntervalsKind } from '../../../../_common/platform/tsx/DiscreteIntervals';

import AttributeDesigner from '../../../../_common/platform/tsx/attributeDesigner/AttributeDesigner';
import AttributeOptionsSelect, { IToggleStates } from '../../../../_common/application/tsx/AttributeOptionsSelect';

import AttributeSortingSelect, {
    AttributeSortingSelectHeader,
    normalizeSorting,
    processSortSet
} from '../../../../_common/platform/tsx/AttributeSortingSelect';

import * as ConfigurationConstants from '../../../../_common/application/ts/ConfigurationConstants';
import * as AttrQueryValuesFormat from '../../../../_common/platform/ts/AttrQueryValuesFormat';

import { IntervalsSelect, isUserDefinedInterval } from '../../../../_common/platform/tsx/IntervalsSelect';

import { ChartElementsFormatSelect } from './ChartElementsFormatSelect';
import { getExpressionType, IExpression } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';
import { SortType } from '../../../../_common/platform/ts/Interfaces';
import { ATTRIBUTE_TYPES } from '../../../../_common/platform/ts/ConfigurationConstants';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import { IAttrQueryValue } from './Interfaces';

export interface IAttrQueryFieldOptions {
    dataSourceID: number;

    chartTypeOwn?;
    chartTypeMainFieldName?: string;
    extendedAxisDisplay_FieldName?: string;
    chartCustomStylesFieldName_inTheme?: string;

    ChartAxisArrayFieldName_inTheme?: string;

    argumentAxisProhibited?: boolean;
    includeSeparateValueAxis?: boolean;
    AxisList?;
    ShowInTooltip_Defaults?;
    Xids?;
    validEntities?: string[]; // Entities that are shown when Allow Multiple Root Entities is unchecked.

    onGetValidAxisMain2?(chartType, extendedAxisDisplay): string;
    onEvalAuxAxisNames?(ChartAxisArrayField): string;
    onGetFullAxisArray?(): any[];
    onGetExtendedAxisArray?(chartType?): any[];
}

export interface IAttrQueryFieldProperties {
    value?: IAttrQueryValue[];
    values?: { [fieldName: string]: any };
    tabID: number;

    options: IAttrQueryFieldOptions;

    border?: boolean;
    themeObj?: IValuesCollection;
    glob: IGlob;
    onChange?(value: IAttrQueryValue): void;
}

function getType(attribute: string, glob: IGlob, dataSourceID: number) {
    return glob.EntityModelsStore.getAttributeType(attribute, dataSourceID);
}

//LL: when 'e'
function getType_ReferredDefault(attribute: string, glob: IGlob, dataSourceID: number) {
    return glob.EntityModelsStore.getDefaultAttributeType(attribute, dataSourceID);
}

function isColorMappingForNumeric(objRow: IAttrQueryValue) {
    let forCMFN =
        objRow.axis === 'XC' &&
        (AttrQueryValuesFormat.isCountAggregate(objRow) ||
            objRow.attrType === 'i' ||
            objRow.attrType === 'r' ||
            objRow.attrType === 'date' ||
            objRow.attrType === 'datetime' ||
            objRow.attrType === 'time');
    return forCMFN;
}

function canFrontEndMapping(value: IAttrQueryValue, attributeType: string) {
    //LL:  not value.attrType, but aType which is different for 'e'
    let canFrontEnd =
        value.axis === 'XC' &&
        (AttrQueryValuesFormat.isCountAggregate(value) ||
            attributeType === 'i' ||
            attributeType === 'r' ||
            attributeType === 'date' ||
            attributeType === 'datetime' ||
            attributeType === 'time' ||
            attributeType === 'b' ||
            attributeType === 's');
    return canFrontEnd;
}

class AttrQueryFieldRow extends React.Component<
    {
        value?: IAttrQueryValue;
        attributeType?: string;
        dataSourceID: number;
        tabID: number;
        i?: number;

        entitiesTree: any[];
        entityCollapsedDict: IToggleStates;

        hasTooltipRole?: boolean;

        chartTypeMain?: string;

        empty?: boolean;
        useCustomStyles?: boolean;
        hasCustomStyles?: boolean;
        chartCustomStyles?: any[];
        curAxis?: any[];
        validAxisMain?: string;
        secondaryAxis?: string;
        extendedAxisArr?: any[];
        axisList?;
        showInTooltip_Defaults?;
        xIDs?;
        visibleEntities: string[];

        onChange?(value: IAttrQueryValue, i: number): void;
        onSortSet?(i: number, value): void;
        onRemove?(i: number): void;
        onEntityCollapsedDictChange?(value): void;

        themeObj?: IValuesCollection;
        glob: IGlob;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    normalize = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            delete value.aggregateGroup;
            delete value.sort;
            delete value.sortOrder;
            delete value.sortOnValues;
            delete value.intervals;
            delete value.mapping;
            delete value.formats;
            delete value.label;
            delete value.customStyle;
            delete value.axis;
            delete value.clickToFilterAttribute;

            if (typeof value.attrType != 'undefined') {
                delete value.attrType;
            }
            return;
        }

        if (value.sort != null && value.sortOnValues == null) {
            value.sortOnValues = false; //VR: WorkItem [102543]: Do not set "sort on value" by default when sorting for attribute is not 'none'
        }

        if (value.sort == null) {
            delete value.sortOnValues;
            delete value.sortOrder;
        }

        if (value.intervals == null) {
            delete value.intervals;
        }

        if (value.formats == null) {
            delete value.formats;
        }

        const attributeType = getType(value.attribute, this.props.glob, this.props.dataSourceID);

        if (attributeType == null) {
            return;
        }

        switch (attributeType) {
            case 's':
                break;
            case 'i':
                break;
            case 'r':
                break;
            case 'e':
                if (!AttrQueryValuesFormat.isCountAggregate(value)) {
                    delete value.intervals;
                }
                break;
            case 'b':
                break;
            case 'none':
                delete value.intervals;
                break;
        }

        let find = _.find(ConfigurationConstants.AGGREGATE_GROUP_VALUES[attributeType], (val) => {
            return val === value.aggregateGroup;
        });

        if (find == null) {
            delete value.aggregateGroup;
        }

        let forColorMappingForNumeric = isColorMappingForNumeric(value); //  "XC" row + number ==  OLD

        if (forColorMappingForNumeric) {
            if (value.mapping == null && value.customStyle != null) {
                value.mapping = {
                    mappingType: 'ColorScale',
                    mappingName: value.customStyle
                }; //  IMappingValue
            }
            delete value.customStyle;
        }
    };

    handleAttributeChange = (values: string[]) => {
        const obj = _.clone(this.props.value || {});
        const newAttribute = values[0];
        const oldType =
            this.props.attributeType != null
                ? this.props.attributeType
                : getType(obj.attribute, this.props.glob, this.props.dataSourceID);
        const newType = getType(newAttribute, this.props.glob, this.props.dataSourceID);

        if (newType !== oldType) {
            delete obj.intervals;
            delete obj.formats;
        }

        obj.attribute = newAttribute;
        obj.attrType = newType;
        delete obj.expression;
        delete obj.clickToFilterAttribute;

        this.handleOnValueChange(obj);
    };

    handleExpressionChange = (expression: IExpression) => {
        const obj = _.clone(this.props.value || {});
        const oldType = obj.attrType;

        obj.expression = expression;
        obj.attrType = getExpressionType(expression);
        delete obj.attribute;

        if (obj.attrType !== oldType) {
            delete obj.intervals;
            delete obj.formats;
        }

        this.handleOnValueChange(obj);
    };

    handleAggregateChange = (value: string) => {
        let obj = _.clone(this.props.value || {});

        if (value === 'none') {
            delete obj.aggregateGroup;
        } else {
            obj.aggregateGroup = value;
        }

        delete obj.formats;

        this.handleOnValueChange(obj);
    };

    handleSortOrderChange = (value) => {
        if (typeof this.props.onSortSet === 'function') {
            this.props.onSortSet(this.props.i, value);
        }
    };

    handleSortChange = (value: string) => {
        let obj = _.clone(this.props.value || {});

        if (value === 'none') {
            delete obj.sort;
        } else {
            obj.sort = value as SortType;
        }

        this.handleOnValueChange(obj);
    };

    handleOnIntervalsChange = (value, withMappings?) => {
        let obj = _.clone(this.props.value || {});

        //   when "withMappings" is On, "value" consists of 2 parts: { intervals: old-value, mapping: mapping }

        if (withMappings === true) {
            //  new only for "XC" row
            obj.intervals = value.intervals;

            if (value.mapping != null) {
                obj.mapping = value.mapping;
            } else {
                delete obj.mapping;
            }

            let forColorMappingForNumeric = isColorMappingForNumeric(obj); //  "XC" row _number  == OLD

            if (forColorMappingForNumeric) {
                delete obj.customStyle;
            }
        } else {
            // old
            obj.intervals = value;
        }

        delete obj.formats;

        this.handleOnValueChange(obj);
    };

    processFormatsChange = (value) => {
        let obj = _.clone(this.props.value || {});
        obj.formats = value;

        this.handleOnValueChange(obj);
    };

    processLabelChange = (value) => {
        let obj = _.clone(this.props.value || {});
        obj.label = value;

        this.handleOnValueChange(obj);
    };

    handleCustomStyleChange = (value: string) => {
        let obj = _.clone(this.props.value || {});

        if (value === 'none') {
            delete obj.customStyle;
        } else {
            obj.customStyle = value;
        }

        this.handleOnValueChange(obj);
    };

    handleShowInTooltipChange = (value: boolean) => {
        let obj = _.clone(this.props.value || {});
        obj.showInTooltip = value;

        this.handleOnValueChange(obj);
    };

    //EVG: It was declared just as 'axisExtended: true,' so it is static, but if it is correct?
    private static axisExtended = true; //LL: 13.05.16: Leo asks to remove "more..." option

    handleAxisChange = (value: string) => {
        if (value === 'ShowAll') {
            AttrQueryFieldRow.axisExtended = true;
        }

        let obj = _.clone(this.props.value || {});

        if (value === 'none') {
            delete obj.axis;
        } else if (value !== 'ShowAll') {
            obj.axis = value;
        }

        this.handleOnValueChange(obj);
    };

    handleOnValueChange = (value: IAttrQueryValue) => {
        this.normalize(value);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleOnRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getAttribute = (value: IAttrQueryValue) => {
        let _value;
        if (value.expression != null) {
            _value = value.expression;
        } else {
            _value = value.attribute;
        }

        return (
            <AttributeDesigner
                tree={this.props.entitiesTree}
                dataSourceID={this.props.dataSourceID}
                modes={['attribute', 'expression']}
                value={_value}
                collapsedDict={this.props.entityCollapsedDict}
                showRemoveButton={true}
                validEntities={this.props.visibleEntities}
                tabID={this.props.tabID}
                onChange={this.handleAttributeChange}
                onExpressionChange={this.handleExpressionChange}
                onCollapsedDictChange={this.props.onEntityCollapsedDictChange}
                onRemove={this.handleOnRemove}
                glob={this.props.glob}
            />
        );
    };

    getAggregate = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        let attributeType: string;

        if (value.attribute != null) {
            attributeType =
                this.props.attributeType != null
                    ? this.props.attributeType
                    : getType(value.attribute, this.props.glob, this.props.dataSourceID);
        } else {
            attributeType = getExpressionType(value.expression);
        }

        const options = _.map(ConfigurationConstants.AGGREGATE_GROUP_VALUES[attributeType], (value, i) => {
            return (
                <option key={value + '-' + i} value={value}>
                    {value}
                </option>
            );
        });

        return (
            <SelectField value={value.aggregateGroup ?? 'none'} onChange={this.handleAggregateChange}>
                <option key="none" value="none">
                    {'none'}
                </option>

                {options}
            </SelectField>
        );
    };

    getSortingSelect(value: IAttrQueryValue) {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        return (
            <AttributeSortingSelect
                value={value}
                onChange={this.handleOnValueChange}
                onSortOrderSet={this.handleSortOrderChange}
            />
        );
    }

    getAttributeType_ofRow = (value: IAttrQueryValue) => {
        let result: string;

        if (value.attribute != null) {
            result =
                this.props.attributeType != null
                    ? this.props.attributeType
                    : getType(value.attribute, this.props.glob, this.props.dataSourceID);
            if (result === 'e') {
                let aTypeRef = getType_ReferredDefault(value.attribute, this.props.glob, this.props.dataSourceID);
                if (aTypeRef != null) {
                    result = aTypeRef;
                }
            }
        } else {
            result = getExpressionType(value.expression);
        }

        return result;
    };

    getIntervals = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        let attributeType = this.getAttributeType_ofRow(value);

        const isCountAggregate = AttrQueryValuesFormat.isCountAggregate(value);

        if (attributeType === ATTRIBUTE_TYPES.ENUMERATION || attributeType === 'none' || attributeType == null) {
            if (isCountAggregate) {
                attributeType = ATTRIBUTE_TYPES.INTEGER;
            } else {
                return;
            }
        }

        const forColorMappingForNumeric = canFrontEndMapping(value, attributeType); //LL: "XC" row, any data type

        if (forColorMappingForNumeric) {
            let targetTypes = [DiscreteIntervalsKind.color]; // array of DiscreteIntervalsKind (enum from DiscreteIntervals) or null for any
            //LL:  old cmfn from customStyle:
            let mapping = value.mapping;

            if (mapping == null) {
                if (value.customStyle != null) {
                    //  old customStyle contains either customStyle or ColorMappingForNumeric
                    // type MappingType = 'DiscreteMapping' | 'ColorScale';
                    mapping = {
                        mappingType: 'ColorScale',
                        mappingName: value.customStyle
                    }; //  IMappingValue
                }
            }

            return (
                <IntervalsSelect
                    value={value.intervals}
                    type={attributeType}
                    withMappings={true}
                    mapping={mapping}
                    targetTypes={targetTypes}
                    allowFrontendAttributeMapping={true}
                    isCountAggregate={isCountAggregate}
                    hideBackendTab={attributeType === ATTRIBUTE_TYPES.BOOLEAN}
                    themeObj={this.props.themeObj}
                    glob={this.props.glob}
                    onChange={this.handleOnIntervalsChange}
                />
            );
        } else {
            let hideBackendTab = attributeType === ATTRIBUTE_TYPES.BOOLEAN ? true : false;

            if (hideBackendTab) {
                return null;
            }

            return (
                <IntervalsSelect
                    value={value.intervals}
                    type={attributeType}
                    onChange={this.handleOnIntervalsChange}
                    themeObj={this.props.themeObj}
                    glob={this.props.glob}
                />
            );
        }
    };

    getFormats = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        let attributeType: string;

        if (value.attribute != null) {
            attributeType =
                this.props.attributeType != null
                    ? this.props.attributeType
                    : getType(value.attribute, this.props.glob, this.props.dataSourceID);

            if (attributeType === ATTRIBUTE_TYPES.ENUMERATION) {
                attributeType = getType_ReferredDefault(value.attribute, this.props.glob, this.props.dataSourceID);
            }
        } else {
            attributeType = getExpressionType(value.expression);
        }

        if (attributeType === ATTRIBUTE_TYPES.INTEGER && AttrQueryValuesFormat.isAvgAggregate(value)) {
            attributeType = ATTRIBUTE_TYPES.REAL;
        }

        if (
            attributeType === ATTRIBUTE_TYPES.ENUMERATION ||
            attributeType === ATTRIBUTE_TYPES.STRING ||
            attributeType === 'none'
        ) {
            if (AttrQueryValuesFormat.isCountAggregate(value)) {
                attributeType = ATTRIBUTE_TYPES.INTEGER;
            } else {
                return;
            }
        }

        //LL: UserDefined Intervals always are of type "s"
        if (isUserDefinedInterval(value.intervals)) {
            //LL: in IntervalsSelect
            return;
        }

        let timePart;

        if (value.intervals != null && value.intervals.timePart != null) {
            timePart = value.intervals.timePart;
        }

        if (timePart === 'none') {
            timePart = null;
        }

        return (
            <ChartElementsFormatSelect
                value={value.formats}
                type={attributeType}
                timePart={timePart}
                aggregateGroup={value.aggregateGroup}
                axis={value.axis}
                chartType={this.props.chartTypeMain}
                onChange={this.processFormatsChange}
                dataSourceID={this.props.dataSourceID}
                themeObj={this.props.themeObj}
                glob={this.props.glob}
            />
        );
    };

    getOptions = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        //LL: Xids: X1, X2, X3
        let use_clickToFilter = _.contains(this.props.xIDs, value.axis) || value.axis === 'A' || value.axis === 'C2F';

        //LL: ========= options param to AttributeOptionsSelect =============

        //LL:  see getShowInTooltip
        let hasTooltipRole = this.props.hasTooltipRole === true;
        let showInTooltip_defaultVal = false;
        if (
            this.props.showInTooltip_Defaults != null &&
            value.axis != null &&
            this.props.showInTooltip_Defaults[value.axis] != null
        ) {
            showInTooltip_defaultVal = this.props.showInTooltip_Defaults[value.axis];
        }
        let showInTooltip_displayVal = value.showInTooltip != null ? value.showInTooltip : showInTooltip_defaultVal;
        if (hasTooltipRole) {
            if (value.axis === 'T') {
                showInTooltip_displayVal = true;
            } else {
                showInTooltip_displayVal = false;
            }
        }

        let options: any = {
            //show_clickToFilter: true,  // default true, as old  But when in Xids !!!
            show_clickToFilter: use_clickToFilter,
            show_showInTooltip: true,
            showInTooltip_disabled: hasTooltipRole,
            showInTooltip_displayVal: showInTooltip_displayVal
        };

        return (
            <AttributeOptionsSelect
                value={value}
                attribute={value}
                dataSourceID={this.props.dataSourceID}
                entitiesTree={this.props.entitiesTree}
                entityCollapsedDict={this.props.entityCollapsedDict}
                disableClickToFilter={false}
                tabID={this.props.tabID}
                options={options}
                onChange={this.handleOnValueChange}
                onEntityCollapsedDictChange={this.props.onEntityCollapsedDictChange}
                glob={this.props.glob}
            />
        );
    };

    getLabel = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        const placeholder = this.props.glob.EntityModelsStore.getReferredAttributeLabel(
            value.attribute,
            this.props.dataSourceID
        );

        return (
            <StringField
                value={value.label || ''}
                placeholder={placeholder}
                applyOnEnter={true}
                changeOnBlurOnly={true}
                onChange={this.processLabelChange}
            />
        );
    };

    getCustomStyle = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        if (this.props.hasCustomStyles !== true) {
            return;
        }

        //LL: X3 without "group" is simply variant of "Y", but stacked.  Change to 'Y3'
        let forCustomStyles = value.axis === 'Y' || (value.axis === 'X3' && value.aggregateGroup != 'group');

        if (!forCustomStyles) {
            return;
        }

        const { chartCustomStyles } = this.props;

        let useCustomStyles = this.props.useCustomStyles;

        if (chartCustomStyles == null || chartCustomStyles.length === 0) {
            useCustomStyles = false;
        }

        //LL: for discrete ColorScales:
        let aType;

        if (value.attribute != null) {
            aType =
                this.props.attributeType != null
                    ? this.props.attributeType
                    : getType(value.attribute, this.props.glob, this.props.dataSourceID);
            if (aType === 'e') {
                aType = getType_ReferredDefault(value.attribute, this.props.glob, this.props.dataSourceID);
            }
        } else {
            aType = getExpressionType(value.expression);
        }

        if (!(useCustomStyles && forCustomStyles)) {
            return;
        }

        const customStyleNames: string[] = [];

        if (useCustomStyles) {
            for (let k = 0; k < chartCustomStyles.length; k++) {
                customStyleNames.push(chartCustomStyles[k].name);
            }
        }

        let arr = [];

        if (forCustomStyles) {
            arr = customStyleNames;
        }

        const options = _.map(arr, (obj, i) => {
            return (
                <option key={obj + '-' + i} value={obj}>
                    {obj}
                </option>
            );
        });

        return (
            <SelectField value={value.customStyle ?? 'none'} onChange={this.handleCustomStyleChange}>
                <option key="none" value="none">
                    {'none'}
                </option>

                {options}
            </SelectField>
        );
    };

    getShowInTooltip = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        let hasTooltipRole = this.props.hasTooltipRole === true;
        let defaultVal = false;

        if (
            this.props.showInTooltip_Defaults != null &&
            value.axis != null &&
            this.props.showInTooltip_Defaults[value.axis] != null
        ) {
            defaultVal = this.props.showInTooltip_Defaults[value.axis];
        }

        let displayVal = value.showInTooltip != null ? value.showInTooltip : defaultVal; // default false

        if (hasTooltipRole) {
            if (value.axis === 'T') {
                displayVal = true;
            } else {
                displayVal = false;
            }
        }

        return (
            <BooleanField
                title={''}
                value={displayVal}
                disabled={hasTooltipRole}
                allowNull={false}
                onChange={this.handleShowInTooltipChange}
            />
        );
    };

    getAxis = (value: IAttrQueryValue) => {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        const { validAxisMain, extendedAxisArr, secondaryAxis } = this.props;

        let axes: any[];

        if (validAxisMain != null && validAxisMain !== '') {
            axes = validAxisMain.split(';');
        } else {
            axes = ['Y', 'Ya', 'Yb', 'X1', 'X1d', 'X2', 'X4', 'X4a', 'X5', 'X3', 'Z_Size'];
        }

        if (extendedAxisArr != null) {
            if (AttrQueryFieldRow.axisExtended === false) {
                for (let k = 0; k < extendedAxisArr.length; k++) {
                    if (value.axis === extendedAxisArr[k]) {
                        AttrQueryFieldRow.axisExtended = true;
                        break;
                    }
                }
            }

            if (AttrQueryFieldRow.axisExtended !== false) {
                axes = axes.concat(extendedAxisArr);
            }
        }

        const secondaryAxisArr = secondaryAxis != null && secondaryAxis !== '' ? secondaryAxis.split(';') : [];
        const initialAxisObj = this.props.axisList ?? {};
        const evalAxis = [];

        for (let k = 0; k < axes.length; k++) {
            evalAxis.push({ title: initialAxisObj[axes[k]], value: axes[k] });
        }

        for (let k = 0; k < secondaryAxisArr.length; k++) {
            const a = secondaryAxisArr[k];

            evalAxis.push({ title: a, value: a });
        }

        const options = _.map(evalAxis, (obj, i) => {
            return (
                <option key={obj.value + '-' + i} value={obj.value}>
                    {obj.title}
                </option>
            );
        });

        let showAllElem;

        if (AttrQueryFieldRow.axisExtended === false) {
            showAllElem = (
                <option
                    style={{
                        fontStyle: 'italic',
                        fontWeight: 'bolder'
                    }}
                    key="ShowAll"
                    value="ShowAll"
                >
                    {'more ...'}
                </option>
            );
        }

        return (
            <SelectField value={value.axis || 'none'} onChange={this.handleAxisChange}>
                <option key="none" value="none">
                    {'none'}
                </option>

                {options}

                {showAllElem}
            </SelectField>
        );
    };

    render() {
        const value = this.props.value || {};

        //LL: ColorMappingForNumeric  to  Mappings column (former "Intervals")
        //LL: and check inside getCustomStyle
        let customStyle;

        if (this.props.hasCustomStyles === true) {
            customStyle = <td className="cell-customStyle">{this.getCustomStyle(value)}</td>;
        }

        //LL:  .cell-formats  uses max-width, that is not applied !
        //   See:  the effect of 'min-width' and 'max-width' on tables, inline tables, table cells, table columns, and column groups is undefined.
        //   So, it is recommended to place div inside td, or use table with table-layout: fixed
        //   But here (when theer are "auto" width for some columns), it seems, better to change order of columns !!
        return (
            <tr className={this.props.empty ? 'empty' : 'attribute-row'}>
                <td className="cell-attribute">{this.getAttribute(value)}</td>
                <td className="cell-group-aggregate">{this.getAggregate(value)}</td>
                <td className="cell-sorting">{this.getSortingSelect(value)}</td>
                <td className="cell-intervals">{this.getIntervals(value)}</td>
                <td className="cell-formats-simple">{this.getFormats(value)}</td>
                <td className="cell-intervals">{this.getOptions(value)}</td>
                {customStyle}
                <td className="cell-label">{this.getLabel(value)}</td>
                <td className="cell-axis">{this.getAxis(value)}</td>
            </tr>
        );
    }
}

export default class AttrQueryField extends React.Component<
    IAttrQueryFieldProperties,
    {
        entityCollapsedDict: IToggleStates;
    }
> {
    private static startIndex;

    private references: {
        tableBody?: HTMLTableSectionElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            entityCollapsedDict: {}
        };
    }

    reorderStart = (e, ui) => {
        AttrQueryField.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (AttrQueryField.startIndex == null) {
            return;
        }

        let startIndex = AttrQueryField.startIndex;
        let stopIndex = $(ui.item).index();

        AttrQueryField.startIndex = null;

        //LL: 29.11.16: see same in AttrQueryMultiField.jsx:
        //LL: 04.10.16 see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
        //   Вызываем cancel, чтобы элементы местами поменял React.js
        //   $(me.getDOMNode()).sortable("cancel");
        const tableBody = this.references.tableBody;
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        this.props.glob.EntityModelsStore.addOnModelsLoadListener(this.handleOnEntityModelsLoaded);
        this.props.glob.EntityModelsActions.loadModels();

        const tableBody = this.references.tableBody;

        $(tableBody).sortable({
            axis: 'y',
            forceHelperSize: true,
            items: 'tr.attribute-row:not(.empty)',
            opacity: 0.8,
            handle: '.cell-attribute',
            cursor: 'grabbing',

            start: this.reorderStart,
            stop: this.reorderStop
        });
    }

    componentWillUnmount() {
        this.props.glob.EntityModelsStore.removeOnModelsLoadListener(this.handleOnEntityModelsLoaded);

        const tableBody = this.references.tableBody;
        if (tableBody != null) {
            $(tableBody).sortable('destroy');
        }
    }

    handleOnEntityModelsLoaded = (loadedDataSources: number[]) => {
        if (loadedDataSources == null) {
            this.setState(this.state);
        }
    };

    processReorder = (start, stop) => {
        if (start === stop) {
            return;
        }

        let value = this.props.value.slice(0);
        let item = value.splice(start, 1);

        value.splice(stop, 0, item[0]);
        this.handleValueChange(value);
    };

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    handleEntityCollapsedDictChange = (value) => {
        this.setState({ entityCollapsedDict: value });
    };

    getFirstDefault(obj, dataType) {
        obj.axis = 'Y';
        obj.sort = 'desc';
        obj.sortOrder = 1;
        obj.sortOnValues = false; //VR: WorkItem [102543]: Do not set "sort on value" by default when sorting for attribute is not 'none'

        if (dataType === 'i' || dataType === 'r') {
            obj.aggregateGroup = 'sum';
        } else {
            obj.aggregateGroup = 'count';
        }

        return obj;
    }

    getSecondDefault(obj, dataType) {
        obj.axis = 'X1';
        obj.aggregateGroup = 'group';

        return obj;
    }

    getSecondDefaultWithoutArgumentsY(obj, dataType) {
        obj.axis = 'Y';

        if (dataType === 'i' || dataType === 'r') {
            obj.aggregateGroup = 'sum';
        } else {
            obj.aggregateGroup = 'count';
        }

        return obj;
    }

    getThirdDefault(obj, dataType, arr) {
        // when arr.length >= 2
        // 1) aggregation
        //    Leo: use Group as default for all other than the first
        //    LL: a bit canny:  use Group as default for 3d, 4th if 1st and 2nd have Aggregation not "none"

        let obj1 = arr[0];
        let obj2 = arr[1];
        obj.aggregateGroup = 'none';

        // 2) axis
        //   Leo:  And if chart type is bar – I would appreciate if you could also make a choice of side-by-side as no. 3
        //       and stacked as no. 4 – so there were always good defaults.
        //   LL:  if chart type is "bar", there is no "stacked" axis (X3),  only for "stackedbar"

        //LL: only when standard obj1 & obj2 and only to bars:
        if (obj1.axis === 'Y' && obj2.axis === 'X1') {
            let chartType = this.getChartTypeMain();
            //LL: for Multi
            if (this.props.options.chartTypeOwn != null) {
                chartType = this.props.options.chartTypeOwn;
            }

            if (chartType === 'bar' || chartType === 'stackedbar' || chartType === 'fullstackedbar') {
                let extendedAxisDisplay = this.getExtendedAxisDisplay();

                let validAxisMain = this.callGetValidAxisMain2(chartType, extendedAxisDisplay);

                let axis = [];
                if (validAxisMain != null && validAxisMain != '') {
                    axis = validAxisMain.split(';');
                }
                //////else axes = ['Y','Ya','Yb','X1','X1d','X2','X4','X4a','X5','X3','Z_Size'];

                //LL: 'bar' - 'Y','X1','X2',   'fullstackedbar' and 'fullstackedbar' - 'Y','X1','X2','X3'

                if (arr.length === 2 && axis.length > 2) {
                    obj.axis = axis[2];
                }

                if (arr.length === 3 && axis.length > 3) {
                    let obj3 = arr[2];
                    if (obj3.axis === axis[2]) {
                        obj.axis = axis[3];
                    }
                }
            }
        }

        return obj;
    }

    getChartTypeMain() {
        let chartTypeMainFieldName = 'chartTypeMain';

        if (this.props.options != null && typeof this.props.options.chartTypeMainFieldName === 'string') {
            chartTypeMainFieldName = this.props.options.chartTypeMainFieldName;
        }

        let result = '';

        if (this.props.values != null) {
            if (this.props.values[chartTypeMainFieldName] != null) {
                result = this.props.values[chartTypeMainFieldName];
            }
        } else {
            alert('LL: AttrQueryField _getChartTypeMain: this.props.values is null. Wrong platform version');
        }

        return result;
    }

    getExtendedAxisDisplay() {
        let extendedAxisDisplay_FieldName = 'extendedAxisDisplay';

        if (this.props.options != null && typeof this.props.options.extendedAxisDisplay_FieldName === 'string') {
            extendedAxisDisplay_FieldName = this.props.options.extendedAxisDisplay_FieldName;
        }

        let result = false;

        if (this.props.values != null) {
            if (this.props.values[extendedAxisDisplay_FieldName] != null) {
                result = this.props.values[extendedAxisDisplay_FieldName];
            }
        } else {
            alert('LL: AttrQueryField _getExtendedAxisDisplay: this.props.values is null. Wrong platform version');
        }

        return result;
    }

    getChartAxisArrayField() {
        let result = [];

        if (this.props.themeObj != null) {
            if (this.props.options != null && this.props.options.ChartAxisArrayFieldName_inTheme != null) {
                result = this.props.themeObj[this.props.options.ChartAxisArrayFieldName_inTheme];
            }
        }

        return result;
    }

    getChartCustomStyles() {
        let result = [];
        let chartCustomStylesFieldName_inTheme;

        if (this.props.options != null && typeof this.props.options.chartCustomStylesFieldName_inTheme === 'string') {
            chartCustomStylesFieldName_inTheme = this.props.options.chartCustomStylesFieldName_inTheme;
        }

        if (chartCustomStylesFieldName_inTheme != null) {
            if (this.props.themeObj != null) {
                if (this.props.themeObj[chartCustomStylesFieldName_inTheme] != null) {
                    result = this.props.themeObj[chartCustomStylesFieldName_inTheme];
                }
            }
        }

        return result;
    }

    handleAddRow = (obj: IAttrQueryValue) => {
        let arr = [...this.props.value];
        let attributeType: string;

        if (obj.attribute != null) {
            attributeType = getType(obj.attribute, this.props.glob, this.props.options.dataSourceID);
        } else if (obj.expression != null) {
            attributeType = obj.expression.rettype;
        }

        if (attributeType == null) {
            return;
        }

        if (arr.length === 0) {
            obj = this.getFirstDefault(obj, attributeType);
        }

        if (arr.length === 1 && this.props.options.argumentAxisProhibited === true) {
            obj = this.getSecondDefaultWithoutArgumentsY(obj, attributeType);
        } else if (arr.length === 1) {
            obj = this.getSecondDefault(obj, attributeType);
        }

        if (arr.length > 1) {
            obj = this.getThirdDefault(obj, attributeType, arr);
        }

        obj.attrType = attributeType;

        //LL: to use in validators
        let chartType = this.getChartTypeMain();
        //LL: for Multi
        if (this.props.options.chartTypeOwn != null) {
            chartType = this.props.options.chartTypeOwn;
        }

        obj.chartTypeMain = chartType; //LL: to use in validators
        arr.push(obj);
        this.handleValueChange(arr);
    };

    handleOnChangeRow = (obj, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];

        if (prev.sort == null && obj.sort != null) {
            processSortSet(i, null, arr);
        }

        normalizeSorting(arr);
        this.handleValueChange(arr);
    };

    handleOnRemoveRow = (i) => {
        let arr = this.props.value.slice(0);

        arr.splice(i, 1);
        normalizeSorting(arr);
        this.handleValueChange(arr);
    };

    handleSortSet = (i, order) => {
        let arr = this.props.value.slice(0);

        processSortSet(i, order, arr);
        this.handleValueChange(arr);
    };

    callGetValidAxisMain2(chartType, extendedAxisDisplay) {
        let result = '';

        if (this.props.options != null && typeof this.props.options.onGetValidAxisMain2 === 'function') {
            result = this.props.options.onGetValidAxisMain2(chartType, extendedAxisDisplay);
        }
        return result;
    }

    callEvalAuxAxisNames(ChartAxisArrayField) {
        let result = '';

        if (this.props.options != null && typeof this.props.options.onEvalAuxAxisNames === 'function') {
            result = this.props.options.onEvalAuxAxisNames(ChartAxisArrayField);
        }

        return result;
    }

    render() {
        let validAxis = '';
        let curAxis = [];
        let addSecondaryAxisToAxisList = this.props.options.includeSeparateValueAxis !== true; //LL: now false
        let secondaryAxis;
        let secondaryAxisArr = [];

        if (addSecondaryAxisToAxisList) {
            const chartAxisArrayField = this.getChartAxisArrayField();
            const auxAxisNames = this.callEvalAuxAxisNames(chartAxisArrayField);

            if (auxAxisNames != null && auxAxisNames != '') {
                secondaryAxisArr = auxAxisNames.split(';');
            }

            secondaryAxis = auxAxisNames;
        }

        let useCustomStyles = true;
        let chartCustomStyles = this.getChartCustomStyles();
        let hasCustomStyles = useCustomStyles === true && chartCustomStyles.length > 0;

        let chartTypeMain = this.getChartTypeMain();
        //LL: for Multi
        if (this.props.options.chartTypeOwn != null) {
            chartTypeMain = this.props.options.chartTypeOwn;
        }

        let xIDs = this.props.options.Xids;
        let axisList = this.props.options.AxisList;

        let ShowInTooltip_Defaults = this.props.options.ShowInTooltip_Defaults;

        let extendedAxisDisplay = this.getExtendedAxisDisplay();

        validAxis = this.callGetValidAxisMain2(chartTypeMain, extendedAxisDisplay);

        let axes = [];
        if (validAxis != null && validAxis != '') {
            axes = validAxis.split(';');
        } else {
            axes = this.props.options.onGetFullAxisArray(); // ['Y','X1','X2','X3','Z_Size']
        }

        let ExtendedAxisArr = [];
        if (typeof this.props.options.onGetExtendedAxisArray === 'function') {
            ExtendedAxisArr = this.props.options.onGetExtendedAxisArray(chartTypeMain);
        }

        axes = axes.concat(secondaryAxisArr);

        for (let j = 0; j < this.props.value.length; j++) {
            let axisValue = this.props.value[j].axis;

            let axisFound = false;
            for (let k = 0; k < axes.length; k++) {
                if (axisValue === axes[k]) {
                    axisFound = true;
                }
            }

            if (!axisFound) {
                for (let k = 0; k < ExtendedAxisArr.length; k++) {
                    if (axisValue === ExtendedAxisArr[k]) {
                        axisFound = true;
                        break;
                    }
                }
            }

            if (!axisFound) {
                //LL: not very good to do it in render ?
                //this.props.value[j].axis = 'none';  // no
                delete this.props.value[j].axis;
            }
        }

        //LL: used in getCustomStyle
        curAxis = _.map(this.props.value, function (obj) {
            //LL: X3 without "group" is simply variant of "Y", but stacked.  Change to 'Y3'
            if (obj.axis === 'X3' && obj.aggregateGroup != 'group') {
                return 'Y3';
            } else {
                return obj.axis;
            }
        });

        //LL: - Role Tooltip:
        let hasTooltipRole = false;

        let find = _.find(this.props.value, (val) => {
            return val.axis === 'T';
        });

        if (find != null) {
            hasTooltipRole = true;
        }

        const entitiesTree = this.props.glob.EntityModelsStore.getEntitiesTreeByDS(this.props.options.dataSourceID); //VR: new
        const rows = _.map(this.props.value, (obj, index) => {
            const attributeType = getType(obj.attribute, this.props.glob, this.props.options.dataSourceID);

            return (
                <AttrQueryFieldRow
                    key={obj.id}
                    i={index}
                    entitiesTree={entitiesTree}
                    value={obj}
                    attributeType={attributeType}
                    entityCollapsedDict={this.state.entityCollapsedDict}
                    dataSourceID={this.props.options.dataSourceID}
                    validAxisMain={validAxis}
                    extendedAxisArr={ExtendedAxisArr}
                    axisList={axisList}
                    showInTooltip_Defaults={ShowInTooltip_Defaults}
                    secondaryAxis={secondaryAxis}
                    xIDs={xIDs}
                    visibleEntities={this.props.options.validEntities}
                    themeObj={this.props.themeObj}
                    tabID={this.props.tabID}
                    chartTypeMain={chartTypeMain}
                    hasTooltipRole={hasTooltipRole}
                    useCustomStyles={useCustomStyles}
                    chartCustomStyles={chartCustomStyles}
                    hasCustomStyles={hasCustomStyles}
                    curAxis={curAxis}
                    glob={this.props.glob}
                    onEntityCollapsedDictChange={this.handleEntityCollapsedDictChange}
                    onChange={this.handleOnChangeRow}
                    onRemove={this.handleOnRemoveRow}
                    onSortSet={this.handleSortSet}
                />
            );
        });

        let customStyle;

        if (hasCustomStyles === true) {
            customStyle = <th className="cell-customStyle">{'Custom Style'}</th>;
        }

        //LL: .cell-formats  uses max-width, that is not applied !
        //   See:  the effect of 'min-width' and 'max-width' on tables, inline tables, table cells, table columns, and column groups is undefined.
        //   So, it is recommended to place div inside td, or use table with table-layout: fixed
        //
        //   But here (when theer are "auto" width for some columns), it seems, better to change order of columns !!

        return (
            <div className={'attrquery-field'}>
                <table className={'table' + (this.props.border === true ? ' table-bordered' : '')}>
                    <thead>
                        <tr>
                            <th className="cell-attribute">{'Attribute'}</th>
                            <th className="cell-group-aggregate">{'Aggregation'}</th>
                            <th className="cell-sorting">
                                <AttributeSortingSelectHeader />
                            </th>
                            <th className="cell-intervals">{'Mappings'}</th>
                            <th className="cell-formats-simple align-center" title="Formats of Chart Elements">
                                {'Formats'}
                            </th>
                            <th className="cell-intervals" title={'More Options'}>
                                {'More...'}
                            </th>
                            {customStyle}
                            <th className="cell-label">{'Label'}</th>
                            <th className="cell-axis">{'Axis / Display'}</th>
                        </tr>
                    </thead>

                    <tbody
                        ref={(input) => {
                            this.references.tableBody = input;
                        }}
                    >
                        {rows}
                        <AttrQueryFieldRow
                            entitiesTree={entitiesTree}
                            entityCollapsedDict={this.state.entityCollapsedDict}
                            dataSourceID={this.props.options.dataSourceID}
                            empty={true}
                            visibleEntities={this.props.options.validEntities}
                            hasTooltipRole={hasTooltipRole}
                            tabID={this.props.tabID}
                            onEntityCollapsedDictChange={this.handleEntityCollapsedDictChange}
                            onChange={this.handleAddRow}
                            themeObj={this.props.themeObj}
                            glob={this.props.glob}
                        />
                    </tbody>
                </table>
            </div>
        );
    }
}
